<template>
    <button
        :class="{ 'active': active === true }"
        @click="togglePanel()"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'ProgramFilterPanelButton',
    data() {
        return {
            active: false,
        };
    },
    methods: {
        togglePanel() {
            this.active = !this.active;

            // setTimeout(() => {
            //     this.$parent.msnry.layout();
            // }, 50);

            // setTimeout(() => {
            //     this.$parent.msnry.layout();
            // }, 200);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/ProgramFilterPanelButton.vue